import { useCallback, useEffect, useState } from 'react';

const useCarousel = (itemCount, initialIndex = 0) => {
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  useEffect(() => {
    if (itemCount === 0) {
      setActiveIndex(0);
      return;
    }

    setActiveIndex(currentIndex => Math.min(currentIndex, itemCount - 1));
  }, [itemCount]);

  const goTo = useCallback(index => {
    if (itemCount === 0) return;

    const nextIndex = ((index % itemCount) + itemCount) % itemCount;
    setActiveIndex(nextIndex);
  }, [itemCount]);

  const next = useCallback(() => {
    goTo(activeIndex + 1);
  }, [activeIndex, goTo]);

  const previous = useCallback(() => {
    goTo(activeIndex - 1);
  }, [activeIndex, goTo]);

  const getOffset = useCallback(index => {
    if (itemCount === 0) return 0;

    let offset = index - activeIndex;
    const halfway = itemCount / 2;

    if (offset > halfway) offset -= itemCount;
    if (offset < -halfway) offset += itemCount;
    return offset;
  }, [activeIndex, itemCount]);

  return {
    activeIndex,
    goTo,
    next,
    previous,
    getOffset,
  };
};

export default useCarousel;
